import { safeNextPath } from '../../shared/next-path.js';

// "Set up my tank" on the display link page: where to return once tank setup
// (onboarding) is done. Kept a day, then dropped, so an abandoned setup does
// not bounce the keeper to an old link page weeks later.
const KEY = 'aqs.afterOnboarding';
const TTL_MS = 24 * 60 * 60 * 1000;

export function rememberAfterOnboarding(path, now = Date.now()) {
  const safe = safeNextPath(path);
  if (!safe) return false;
  try {
    localStorage.setItem(KEY, JSON.stringify({ path: safe, at: now }));
    return true;
  } catch {
    return false;
  }
}

// Read once: the value is removed as it is read, so it can fire only once.
export function takeAfterOnboarding(now = Date.now()) {
  let raw;
  try {
    raw = localStorage.getItem(KEY);
    if (raw !== null) localStorage.removeItem(KEY);
  } catch {
    return null;
  }
  if (!raw) return null;
  try {
    const v = JSON.parse(raw);
    if (!v || typeof v.at !== 'number' || now - v.at > TTL_MS || now < v.at) return null;
    return safeNextPath(v.path);
  } catch {
    return null;
  }
}
